import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaFileInvoice, FaRegListAlt, FaUsers, FaFileExcel } from 'react-icons/fa';
import { FiGlobe, FiBox, FiFileText, FiCreditCard, FiSettings, FiBriefcase, FiSliders, FiMail } from 'react-icons/fi';
import { MdKeyboardArrowDown } from 'react-icons/md';
import logoFiskaGroup from './../assets/images/logos/fiskagroup.png';
import { useAuth } from '../services/auth.service';

const Header = () => {
    const location = useLocation();
    const { canAdmin } = useAuth();
    const [isAdminOpen, setIsAdminOpen] = useState(false);

    // Helper: accept a string or array of base paths and consider active if
    // pathname === base OR pathname starts with `${base}/`
    const isActive = (bases) => {
        const list = Array.isArray(bases) ? bases : [bases];
        return list.some((base) =>
            location.pathname === base || location.pathname.startsWith(`${base}/`)
        );
    };

    const navLinkClass = (bases) =>
        `flex items-center gap-2 px-3 py-2 rounded-md transition-all duration-150 ${isActive(bases)
            ? 'bg-primary/10 text-primary font-semibold'
            : 'text-gray-600 hover:bg-gray-100 hover:text-primary'
        }`;

    return (
        <header className="bg-white shadow-sm px-4 sm:px-6 py-3 fixed top-0 left-0 w-full z-50 border-b border-gray-200">
            <div className="flex justify-between items-center mx-auto">
                {/* Logo */}
                <Link to="/" className="flex items-center gap-2">
                    <img src={logoFiskaGroup} alt="FiskaGroup Logo" className="hidden xl:flex h-10" />
                </Link>

                {/* Navigation */}
                <nav>
                    <ul className="flex items-center gap-1 sm:gap-2 md:gap-3 lg:gap-4 xl:gap-5 2xl:gap-6 text-sm sm:text-base relative">
                        <li>
                            <Link to="/" className={navLinkClass('/')}>
                                <FaRegListAlt className="text-md" />
                                Dashboard
                            </Link>
                        </li>

                        <li>
                            <Link to="/payment-link" className={navLinkClass('/payment-link')}>
                                <FaRegListAlt className="text-md" />
                                Lien de paiement
                            </Link>
                        </li>

                        <li>
                            <Link to="/users" className={navLinkClass(['/users', '/user'])}>
                                <FaUsers className="text-md" />
                                Utilisateurs
                            </Link>
                        </li>

                        <li>
                            <Link to="/transactions" className={navLinkClass('/transactions')}>
                                <FaFileInvoice className="text-md" />
                                Transactions
                            </Link>
                        </li>

                        <li>
                            <Link to="/accounting-export" className={navLinkClass('/accounting-export')}>
                                <FaFileExcel className="text-md" />
                                Export comptable
                            </Link>
                        </li>

                        {/* Administration dropdown */}
                        {canAdmin && (
                            <li
                                className="relative"
                                onMouseEnter={() => setIsAdminOpen(true)}
                                onMouseLeave={() => setIsAdminOpen(false)}
                            >
                                <button
                                    className={`flex items-center gap-2 px-3 py-2 rounded-md transition-all duration-150 ${isActive(['/subdomains', '/subdomain', '/services', '/service', '/documents', '/document', '/banks', '/bank', '/societies', '/society', '/fields', '/field', '/email-templates'])
                                        ? 'bg-primary/10 text-primary font-semibold'
                                        : 'text-gray-600 hover:bg-gray-100 hover:text-primary'
                                        }`}
                                >
                                    <FiSettings className="text-md" />
                                    Administration
                                    <MdKeyboardArrowDown className="text-lg" />
                                </button>

                                {isAdminOpen && (
                                    <ul className="absolute left-0 top-full bg-white border border-gray-200 rounded-md shadow-lg w-56 py-2 z-50">
                                        <li>
                                            <Link to="/subdomains" className={navLinkClass(['/subdomains', '/subdomain'])}>
                                                <FiGlobe className="text-md" /> Sous-domaines
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/services" className={navLinkClass(['/services', '/service'])}>
                                                <FiBox className="text-md" /> Services
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/documents" className={navLinkClass(['/documents', '/document'])}>
                                                <FiFileText className="text-md" /> Documents
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/societies" className={navLinkClass(['/societies', '/society'])}>
                                                <FiBriefcase className="text-md" /> Sociétés internes
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/banks" className={navLinkClass(['/banks', '/bank'])}>
                                                <FiCreditCard className="text-md" /> Banques
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/fields" className={navLinkClass(['/fields', '/field'])}>
                                                <FiSliders className="text-md" /> Champs
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to="/email-templates" className={navLinkClass('/email-templates')}>
                                                <FiMail className="text-md" /> Modèles d’email
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </li>
                        )}
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;